export const handleMissingResponse = ( data ) => {
	if ( !data || !data.response ) {
		throw new Error( 'Server Error' );
	}
};
